"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ChatList_1 = __importDefault(require("./ChatList"));
const Header_1 = __importDefault(require("./Header"));
const SearchResults_1 = __importDefault(require("./SearchResults"));
const SearchBox_1 = __importDefault(require("../shared/SearchBox"));
const MyAvatar_1 = __importDefault(require("./MyAvatar"));
const UserMenu_1 = __importDefault(require("./UserMenu"));
const PLACEHOLDER_TEXT = "Search chats and messages";
exports.default = react_1.default.memo(DefaultPanel);
function DefaultPanel() {
    const [inputText, setInputText] = react_1.useState("");
    const myUsername = react_redux_1.useSelector((state) => { var _a; return (_a = state.usersState.me) === null || _a === void 0 ? void 0 : _a.username; });
    const contentPanel = inputText.length
        ? react_1.default.createElement(SearchResults_1.default, { searchTerm: inputText, clearSearchTerm: () => setInputText("") })
        : react_1.default.createElement(ChatList_1.default, null);
    const avatar = react_1.default.createElement(MyAvatar_1.default, { size: "sm" });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { leftIcon: avatar, title: myUsername, rightIcon: react_1.default.createElement(UserMenu_1.default, null) }),
        react_1.default.createElement(SearchBox_1.default, { text: inputText, onChange: setInputText, placeholderText: PLACEHOLDER_TEXT }),
        contentPanel));
}
